import { render, staticRenderFns } from "./ChooseContract.vue?vue&type=template&id=7f8bfe24&scoped=true&"
import script from "./ChooseContract.vue?vue&type=script&lang=js&"
export * from "./ChooseContract.vue?vue&type=script&lang=js&"
import style0 from "./ChooseContract.vue?vue&type=style&index=0&id=7f8bfe24&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f8bfe24",
  null
  
)

export default component.exports